module.exports = __webpack_public_path__ + "static/erika-and-ken-720813843c85ce4a427f14e16618c4f0.png";